<div class="title">
  <mat-icon>settings</mat-icon>
  <ng-container *ngIf="viewOptions && viewOptions.length > 0"> {{ viewOptions[0].typeName }} </ng-container>
</div>
<div class="description">SELECT THE VIEW OPTIONS</div>

<div class="options">
  <elements-filter-chip
    *ngFor="let option of viewOptions"
    [icon]="option.icon"
    [caption]="option.displayName"
    [selected]="isSelected(option)"
    (click)="isSelected(option) ? removeProduct(option) : switchProduct(option)"
    [matTooltip]="option.description"
  >
  </elements-filter-chip>
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">View</button>
  <button styles-low-button (click)="clear()">Reset</button>
</div>
